import Select from "react-select";
import PropTypes from "prop-types";

export const InputSelect = props => {
  const {
    arr = [],
    id,
    formik,
    label = "xxx",
    llave_texto = "nombre",
    llave_valor = "id",
    ejecute,
    disabled = false,
    clases = "",
    subKey = "",
    placeholder = "---Seleccione---",
  } = props;
  const arrOpts = (t, texto, valor) => t.map(el => ({ label: el[texto], value: valor ? el[valor] : el }));

  return (
    <>
      {Boolean(label) && label !== "xxx" && <label htmlFor={id}>{label}</label>}
<Select
  key={subKey}
  isDisabled={disabled}
  texto=""
  name={id}
  id={id}
  className={`selectDos ${clases}`}
  onChange={e => {
    formik ? formik.setValues({ ...formik.values, [id]: e ? e.value : "" }) : ejecute(e);
  }}
  placeholder={placeholder}
  isClearable={true}
  classNamePrefix={"limpiarSelect"}
  options={arrOpts(arr, llave_texto, llave_valor)}
  menuPortalTarget={typeof document !== "undefined" ? document.body : null}
  styles={{
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    menu: base => ({ ...base, zIndex: 9999 }),
  }}
/>
    </>
  );
};

InputSelect.propTypes = {
  arr: PropTypes.array,
  id: PropTypes.string,
  formik: PropTypes.object,
  label: PropTypes.string,
  llave_texto: PropTypes.string,
  llave_valor: PropTypes.string,
  ejecute: PropTypes.func,
  disabled: PropTypes.bool,
  clases: PropTypes.string,
  subKey: PropTypes.string,
  placeholder: PropTypes.string,
};
